module.exports = __webpack_public_path__ + "static/media/AgentCall.9b996f4f.svg";